<template>
  <v-container>
    <v-card max-width="500" class="mx-auto">
      <v-form v-model="validForm">
        <v-row class="mx-2">
          <v-col cols="5" align="center">
            <h4>{{ $t("company.tabs.branding.logo") }}</h4>
            <div class="grey lighten-2" style="width: 140px; height: 140px">
              <input
                type="file"
                style="display: none"
                ref="image"
                accept="image/x-png"
                @change="onFilePicked"
              />
              <v-img class="white" v-if="imageSrc || imageUrl" :src="imageSrc || imageUrl"></v-img>
            </div>
            <small>{{ $t("company.tabs.branding.logo_description") }}</small>
            <v-btn class="mt-1" color="primary" dark @click="$refs.image.click()">
              <v-icon left>mdi-image</v-icon>{{ $t("company.tabs.branding.button_choose_file") }}
            </v-btn>
          </v-col>

          <v-col cols="6" offset="1" align="center">
            <h4 class="mb-2">{{ $t("company.tabs.branding.primary_color") }}</h4>

            <v-text-field
              prefix="#"
              :rules="colorRules"
              :label="$t('company.tabs.branding.color')"
              :hint="$t('company.tabs.branding.color_hint')"
              v-model="primaryColor"
            >
              <template v-slot:prepend-inner>
                <div
                  :style="`height:30px;width:30px; border-radius:15px;
                  background-color:#${primaryColor};`"
                ></div>
              </template>
            </v-text-field>
            <h4 class="mb-2">{{ $t("company.tabs.branding.secondary_color") }}</h4>
            <v-text-field
              prefix="#"
              :rules="colorRules"
              :label="$t('company.tabs.branding.color')"
              :hint="$t('company.tabs.branding.color_hint')"
              v-model="secondaryColor"
            >
              <template v-slot:prepend-inner>
                <div
                  :style="`height:30px;width:30px;border-radius:15px;
                  background-color:#${secondaryColor};`"
                ></div>
              </template>
            </v-text-field>
          </v-col>
        </v-row>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn :loading="saving" class="primary" @click="saveData()">{{
            $t("common.save")
          }}</v-btn>
        </v-card-actions>
        <!-- </v-container> -->
      </v-form>
    </v-card>
    <v-snackbar :timeout="15000" v-model="snackbar">
      {{ feedback }}
      <v-btn color="primary" text @click="snackbar = false">{{ $t("common.close") }}</v-btn>
    </v-snackbar>
  </v-container>
</template>

<script>
import firestore from "@/firebase/firestore";
import storage from "@/firebase/storage";

export default {
  name: "Settings",
  components: {},
  props: ["companyId"],
  data() {
    return {
      primaryColor: null,
      secondaryColor: null,
      imageSrc: null,
      file: null,
      saving: false,
      snackbar: false,
      imageUrl: null,
      validForm: false,
      colorRules: [
        (v) => v.length === 0 ||
          new RegExp("^[a-fA-F0-9]{6}$").test(v) ||
          this.$t("company.tabs.branding.invalid_colors"),
      ],
      feedback: null,
    };
  },
  methods: {
    saveData() {
      if (!this.validForm) {
        this.feedback = this.$t("company.tabs.branding.invalid_colors");
        this.snackbar = true;
        return;
      }
      this.saving = true;
      this.snackbar = false;
      const data = {};
      if (this.primaryColor) {
        data.primary_color = `#${this.primaryColor}`;
      }
      if (this.secondaryColor) {
        data.secondary_color = `#${this.secondaryColor}`;
      }

      const company = this.$store.state.companies[this.$props.companyId];

      if (Object.keys(data).length > 0) {
        firestore.updateCompany(company.id, data);
      }

      this.feedback = this.$t("company.tabs.branding.save_image");

      if (this.file) {
        const filePath = `companies/${company.id}/images/${this.file.name}`;
        storage.uploadFile(this.file, filePath).then(() => {
          firestore.updateCompany(company.id, { logo: filePath });
          this.saving = false;
          this.snackbar = true;
        });
      } else {
        console.log("no image, that was fast!");
        this.saving = false;
        this.snackbar = true;
      }
    },

    onFilePicked(e) {
      const { files } = e.target;
      if (files[0] !== undefined) {
        const fr = new FileReader();
        fr.readAsDataURL(files[0]);
        fr.addEventListener("load", () => {
          [this.file] = files;
          this.imageSrc = fr.result;
        });
      }
    },
    decimalToHexString(number) {
      let num = number;
      if (number < 0) {
        num = 0xffffffff + number + 1;
      }
      return num.toString(16); // .toUpperCase();
    },
  },
  created() {
    const company = this.$store.state.companies[this.$props.companyId];
    if (!company) {
      return;
    }

    if (company.logo) {
      this.imageUrl = this.$store.getters.getImageUrlById(company.id);
    }

    console.log(company);
    this.primaryColor =
      company.primary_color != null ? company.primary_color.replace("#", "") : "f94242";
    this.secondaryColor =
      company.secondary_color != null ? company.secondary_color.replace("#", "") : "429ef9";
  },
};
</script>
